<template>
  <div class="all">
    <div class="warp">
      <div class="warp-header">
        <h2>新增定时报告模板</h2>
      </div>
      <div class="warp-body clearfix mb60">
        <!-- 建方案 -->
        <div class="form-warp input-list name-width0">
          <h4 class="">接收人设置</h4>
          <div class="item mt15 clearfix report-drop">
            <span class="name fl">微信:</span>
            <div class="input-father report-btn" @click="isHasUser(1)">
              <input class="input-text" type="text" placeholder="请点击输入框添加接收人的微信账号" v-model.trim="reportForm.wx"
                readonly />
            </div>
            <div class="clearfix report-down" v-if="wxList.length > 0">
              <div class="input-father checkbox-group">
                <label class="checkbox-box mt10" v-for="(item, index) in wxList" :key="index">
                  <label class="checkbox-warp fl" :class="{ curr: checkedWx.indexOf(JSON.stringify(item)) != -1 }">
                    <input name="" type="checkbox" class="checkbox" :value="JSON.stringify(item)" v-model="checkedWx" />
                    <i class="icons checkbox-icon"></i>
                  </label>
                  <div class="hidden ac" :title="item.username">{{ item.username }}</div>
                </label>
              </div>
            </div>
          </div>
          <div class="item mt15 clearfix report-drop">
            <span class="name fl">邮箱:</span>
            <div class="input-father report-btn" @click="isHasUser(2)">
              <input class="input-text" type="text" placeholder="填写接收人邮箱地址，多个地址请用,隔开" v-model.trim="reportForm.email"
                readonly />
            </div>
            <div class="clearfix report-down" v-if="emailList.length > 0">
              <div class="input-father checkbox-group">
                <label class="checkbox-box mt10" v-for="(item, index) in emailList" :key="index">
                  <label class="checkbox-warp fl" :class="{ curr: checkedEmail.indexOf(JSON.stringify(item)) != -1 }">
                    <input name="" type="checkbox" class="checkbox" :value="JSON.stringify(item)"
                      v-model="checkedEmail" />
                    <i class="icons checkbox-icon"></i>
                  </label>
                  <div class="hidden ac" :title="item.username">{{ item.username }}</div>
                </label>
              </div>
            </div>
          </div>
          <div class="item mt15 clearfix report-drop">
            <span class="name fl">手机:</span>
            <div class="input-father report-btn" @click="isHasUser(3)">
              <input class="input-text" type="text" placeholder="填写接收人手机号码，多个号码请用,隔开，使用短信接收可能会产生额外费用"
                v-model.trim="reportForm.tel" readonly />
            </div>
            <div class="clearfix report-down" v-if="telList.length > 0">
              <div class="input-father checkbox-group">
                <label class="checkbox-box mt10" v-for="(item, index) in telList" :key="index">
                  <label class="checkbox-warp fl" :class="{ curr: checkedTel.indexOf(JSON.stringify(item)) != -1 }">
                    <input name="" type="checkbox" class="checkbox" :value="JSON.stringify(item)" v-model="checkedTel" />
                    <i class="icons checkbox-icon"></i>
                  </label>
                  <div class="hidden ac" :title="item.username">{{ item.username }}</div>
                </label>
              </div>
            </div>
          </div>
          <h4 class="mt20">发送频率设置</h4>
          <div class="item mt15 clearfix">
            <div class="corm clearfix">
              <span class="element" v-for="(item, index) in sendTypeList" :key="index"
                :class="{ 'curr': curSendType == index }" @click="sendType(index)">{{ item }}</span>
              <!-- 每个发送频率提示文字 -->
              <p class="mt5 ml5 fl fs12 color-red">（{{ curSendText[curSendType] }}）</p>
            </div>
            <div class="time-term">
              <div class="clearfix">
                <div class="" v-if="curSendType == 0">
                  <div class="fl">
                    <span class="child">{{ curName }}</span>
                    <span class="drop-down mores" v-for="(item1, index1) in dateList" :key="index1">
                      <button class="btn btn-lightblue"><span class="text">00</span> <i class="icons"></i></button>
                      <ul class="option sm">
                        <li v-for="(item, index) in item1.time" :key="index" @click="choseTime(item, item1.name)">{{ item }}
                        </li>
                      </ul>
                      <span class="child">{{ item1.name }}</span>
                    </span>
                  </div>
                  <label class="checkbox-box ml20 fl">
                    <label class="checkbox-warp fl" :class="{ 'curr': reportForm.checked }"><input type="checkbox"
                        name="chooseInfo" value="0" class="checkbox" v-model="reportForm.checked"> <i
                        class="icons checkbox-icon"></i></label>
                    包含周、六日
                  </label>
                </div>

                <div v-if="curSendType == 1">
                  <span class="child">{{ curName }}</span>
                  <span class="drop-down mores" v-for="(item1, index1) in dateList" :key="index1">
                    <button class="btn btn-lightblue"><span class="text">{{ item1.curTime }}</span> <i
                        class="icons"></i></button>
                    <ul class="option sm">
                      <li v-for="(item, index) in item1.time" :key="index" @click="choseTime(item, item1.name, index)">
                        {{ item }}</li>
                    </ul>
                    <span class="child">{{ item1.name }}</span>
                  </span>
                </div>
                <div v-if="curSendType == 2">
                  <span class="child">{{ curName }}</span>
                  <span class="drop-down mores" v-for="(item1, index1) in dateList" :key="index1">
                    <button class="btn btn-lightblue"><span class="text">00</span> <i class="icons"></i></button>
                    <ul class="option sm">
                      <li v-for="(item, index) in item1.time" :key="index" @click="choseTime(item, item1.name)"
                        :class="{ 'disabled': (28 < item && item1.name == '日') }">{{ item }}</li>
                    </ul>
                    <span class="child">{{ item1.name }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <h4 class="mt20">选择模板</h4>
          <div class="item mt15 clearfix">
            <span class="name fl"><i class="color-red">*</i> 选择模板:</span>
            <div class=" heng">
              <span class="drop-down fl">
                <button class="btn btn-lightblue">{{ curTpl }}<i class="icons"></i></button>
                <ul class="option ac">
                  <vue-scroll :ops="ops" :style="{ height: scrollH }">
                    <li style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" class="wh50 fl"
                      v-for="(item, index) in reportTemplate" :key="index" @click="choseTemple(item.id, item.tpl_name)"
                      :title="item.tpl_name">{{ item.tpl_name }}</li>
                  </vue-scroll>
                </ul>
              </span>
              <button class="btn btns fr"><i class="icons add-icon1"></i><span class="color-blue"
                  @click="addTemple()">新建模板</span></button>
            </div>
          </div>
          <h4 class="mt20">更多设置</h4>
          <div class="item clearfix">
            <span class="name fl">情感属性：</span>
            <div class="input-father checkbox-group">
              <label class="checkbox-box">
                <label class="checkbox-warp fl" :class="sentiment.indexOf('正面') != -1 ? 'curr' : ''"><input name=""
                    v-model="sentiment" type="checkbox" value="正面" class="checkbox"> <i
                    class="icons checkbox-icon"></i></label>
                <div class="hidden ac">正面</div>
              </label>
              <label class="checkbox-box">
                <label class="checkbox-warp fl" :class="sentiment.indexOf('中性') != -1 ? 'curr' : ''"><input name=""
                    v-model="sentiment" type="checkbox" value="中性" class="checkbox"> <i
                    class="icons checkbox-icon"></i></label>
                <div class="hidden ac">中性</div>
              </label>
              <label class="checkbox-box">
                <label class="checkbox-warp fl" :class="sentiment.indexOf('负面') != -1 ? 'curr' : ''"><input name=""
                    v-model="sentiment" type="checkbox" value="负面" class="checkbox"> <i
                    class="icons checkbox-icon"></i></label>
                <div class="hidden ac">负面</div>
              </label>
            </div>
          </div>
          <div class="item clearfix">
            <span class="name fl">定向信源：</span>
            <div class="input-father checkbox-group">
              <label class="checkbox-box" v-for="(item, index) in configInfo.isFocusList" :key="index">
                <label class="checkbox-warp fl" :class="source.indexOf(index) != -1 ? 'curr' : ''">
                  <input name="" type="checkbox" class="checkbox" v-model="source" :value="index" />
                  <i class="icons checkbox-icon"></i>
                </label>
                <div class="hidden ac">{{ item }}</div>
              </label>
            </div>
          </div>
          <div class="item clearfix">
            <span class="name fl">匹配模式：</span>
            <div class="input-father checkbox-group">
              <label class="checkbox-box" v-for="(item, index) in mateList" :key="index">
                <label class="checkbox-warp fl" :class="{ curr: parseInt(searchMode) === index + 1 }"><input
                    v-model="searchMode" name="xinyuan" type="radio" :value="index + 1" class="radio"> <i
                    class="icons radio-icon"></i></label>
                <div class="hidden ac">{{ item }}</div>
              </label>
            </div>
          </div>
          <div class="item clearfix">
            <span class="name fl">媒体类型：</span>
            <div class="input-father checkbox-group">
              <label class="checkbox-box" v-for="(item, index) in MediaPlatformList" :key="index">
                <label class="checkbox-warp fl" :class="{ 'curr': mediaType.indexOf(index) != -1 }">
                  <input name="" type="checkbox" class="checkbox" v-model="mediaType" :value="index" />
                  <i class="icons checkbox-icon"></i>
                </label>
                <div class="ovhidden ac">{{ item }}</div>
              </label>
            </div>
          </div>
          <div class="item clearfix">
            <span class="name fl">包含方案：</span>
            <div class="input-father checkbox-group">
              <label class="checkbox-box caseList" v-for="(item, index) in caseList" :key="index">
                <label class="checkbox-warp fl" @click="delIncloudIndex(item.id, index)"
                  :class="{ 'curr': caseIds.indexOf(item.id) != -1 }">
                  <input name="" type="checkbox" class="checkbox" v-model="caseIds" :value="item.id"
                    :disabled="caseId === item.id ? true : false" />
                  <i class="icons checkbox-icon"></i>
                </label>
                <div class="ovhidden ac" :title="item.name">{{ item.name }}</div>
              </label>
            </div>
          </div>
          <div class="item clearfix" v-if="includeMainWordList.length > 0 && zhutiShow">
            <span class="name fl">主&nbsp;体&nbsp;词&nbsp;：</span>
            <div class="input-father checkbox-group">
              <div v-for="(item, index) in includeMainWordList" :key="index" class="d-flex" style="flex-wrap:wrap">
                <label class="checkbox-box includeWordList" style="display:flex"
                  v-for="(item1, index1) in item.keywordsMain" :key="index1">
                  <i class="close" @click="delIncloudMainWord(index, index1)" v-if="item.id != caseId">&times;</i>
                  <div class="ovhidden ac" :title="item1">{{ item1 }}</div>
                </label>
              </div>
            </div>
          </div>
          <div class="item clearfix" v-if="includeWordList.length > 0 && fenxiShow">
            <span class="name fl">分&nbsp;析&nbsp;词&nbsp;：</span>
            <div class="input-father checkbox-group">
              <div v-for="(item, index) in includeWordList" :key="index" class="d-flex" style="flex-wrap:wrap">
                <label class="checkbox-box includeWordList" style="display:flex" v-for="(item1, index1) in item.keywords"
                  :key="index1">
                  <i class="close" @click="delIncloudWord(index, index1)" v-if="item.id != caseId">&times;</i>
                  <div class="ovhidden ac" :title="item1">{{ item1 }}</div>
                </label>
              </div>
            </div>
          </div>

          <div class="form-btn">
            <button class="btn save btn-jbblue" @click="saveReport()">保存</button>
            <button class="btn save btn-none" @click="cancelReport()">取消</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import VueDatepickerLocal from 'vue-datepicker-local';
import Dialog from '../../../components/dialog.vue';
export default {
  computed: {
    ...mapState({
      platformList: state => state.show.companyinfo.platformList,
      configInfo: state => state.show.companyinfo
    })
  },
  data() {
    return {
      sid: this.$route.query.id,
      caseId: '',
      templateId: 0,
      checkedWx: [],
      curWx: '',
      curEmail: '',
      checkedEmail: [],
      curTel: '',
      checkedTel: [],
      wxList: [],
      emailList: [],
      telList: [],
      wxShow: true,
      sendTypeList: ['按天', '按星期', '按月'],  //发送频率类型
      curName: '每天', //当前频率类型
      curSendType: 0,//频次类型
      curSendText: ['日报统计时间为报告发送时间近24小时内信息', '周报统计时间为报告发送时间至上周同一时间段信息 ', '月报统计时间为报告发送时间至上月同一时间段信息'],//频次提示文字
      dateList: [],
      weeks: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      minute: '00',
      hour: '00',
      //time:new Date(),
      reportTemplate: [],
      curTpl: '请选择简报模板',
      reportForm: {},
      email: '',
      tel: '',
      reportTime: '',
      weekReportTime: 0,
      curDateArr: [],
      isWeek: 0,
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          keepShow: true
        },
        bar: {
          hoverStyle: true,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: '#c4c4cc',
        }
      },
      scrollH: '150px',
      // 更多设置
      pageType: 0,//因为监听回显所以加参数判断是第一次通过接口来的就不进入监听方法 值为1
      mateList: ['精准匹配', '模糊匹配'],
      searchMode: 1,//已选匹配模式
      sentiment: ['正面', '中性', '负面'],//情感属性
      source: [0],//定向信源
      MediaPlatformList: [],//媒体类型
      mediaType: ['total'],//所选媒体类型
      currWordList: '',
      caseNum: 0,//所选方案
      curIncloudWord: null,
      caseIds: [],//所有方案的Id
      caseList: [],//所有方案关键词
      caseType: [],//所选方案
      includeWordList: [],//包含词
      includeMainWordList: [],//主体词
      currWordMainList: '',//当前主体词
      zhutiShow: false,
      fenxiShow: false
    }
  },
  components: {
    VueDatepickerLocal, Dialog
  },
  created() {
    // 获取缓存方案数据
    this.caseId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    this.caseName = JSON.parse(sessionStorage.getItem('planStorage')).name;
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.allNewReport();
      that.getUserMethod('wx');
      that.getUserMethod('email');
      that.getUserMethod('tel');
      that.getMediaCase();
    })
  },
  watch: {
    platformList: {
      handler() {
        let map_ = new Map();
        for (let item of this.platformList) {
          map_.set(item.type, item.name)
        }
        let obj = Object.create(null);
        for (let [k, v] of map_) {
          obj[k] = v;
        }
        this.MediaPlatformList = obj;
      }, immediate: true
    },
    caseIds() {
      let that = this, nameArr = [], numArr = [], tempArr = [], tempmArr = [];
      if (that.pageType === 1 && that.includeWordList.length > 0) {
        that.pageType = 0;
        return;
      }
      let len = that.caseIds.length;
      console.log(that.caseNum,len)
      if (that.caseNum > len) {
        // that.isDel = true;
        that.caseNum = len;
        that.delIncloudWords();
        that.delIncloudMainWords();
        return
      } else if (that.caseNum == len) {
        return
      }
      that.caseList.forEach((ele, index) => {
        if (ele.id == that.caseIds[len - 1]) {
          let temp = {}, tempm = {};
          temp.id = ele.id;
          tempm.id = ele.id;
          temp.keywords = [];
          tempm.keywordsMain = [];
          temp.keywordsMain = [];
          ele.keywords_final.forEach(ele1 => {
            temp.keywords.push(ele1);
          });
          ele.keywords_main.forEach(ele1 => {
            temp.keywordsMain.push(ele1);
          });
          tempArr.push(temp);
          tempmArr.push(tempm);
          that.includeWordList.push(temp);
          that.includeMainWordList.push(tempm);
        }
      });
      that.pageType = 0;
      that.caseNum = len;
      let zhutiarr = [];
      let fenxiarr = [];
      for (let item of that.includeMainWordList) {
        if (item.keywordsMain && item.keywordsMain.length > 0) {
          zhutiarr = zhutiarr.concat(item.keywordsMain)
        }
      }
      for (let item of that.includeWordList) {
        if (item.keywords && item.keywords.length > 0) {
          fenxiarr = fenxiarr.concat(item.keywords)
        }
      }
      if (zhutiarr.length > 0) {
        that.zhutiShow = true;
      } else {
        that.zhutiShow = false;
      }
      if (fenxiarr.length > 0) {
        that.fenxiShow = true;
      } else {
        that.fenxiShow = false;
      }
    },
    mediaType() {
      let that = this;
      let len = that.mediaType.length;
      if (that.mediaType[0] === 'total' && len > 1) {//选择非全部
        that.mediaType.splice(0, 1);
      } else if (that.mediaType[len - 1] === 'total' && len > 1) {
        that.mediaType = ['total'];
      }
    },
    checkedWx() {
      let that = this, nameArr = [], idArr = [];
      that.checkedWx.forEach((ele, index) => {
        let tempEle = JSON.parse(ele);
        nameArr.push(tempEle.username)
        idArr.push(tempEle.id)
      });
      let tempWx = nameArr.toString();
      that.curWx = idArr.toString();
      that.$set(that.reportForm, 'wx', tempWx);
    },
    checkedEmail() {
      let that = this, nameArr = [], idArr = [];
      // console.log(that.checkedEmail);
      that.checkedEmail.forEach((ele, index) => {
        let tempEle = JSON.parse(ele);
        nameArr.push(tempEle.username)
        idArr.push(tempEle.id)
      });
      let tempWx = nameArr.toString();
      that.curEmail = idArr.toString();
      that.$set(that.reportForm, 'email', tempWx);
    },
    checkedTel() {
      let that = this, nameArr = [], idArr = [];
      that.checkedTel.forEach((ele, index) => {
        let tempEle = JSON.parse(ele);
        nameArr.push(tempEle.username)
        idArr.push(tempEle.id)
      });
      let tempWx = nameArr.toString();
      that.curTel = idArr.toString();
      that.$set(that.reportForm, 'tel', tempWx);
    },
    source() {
      let that = this;
      let len = that.source.length;
      if (that.source[0] === 0 && len > 1) {//选择非全部
        that.source.splice(0, 1);
      } else if (that.source[len - 1] === 0 && len > 1) {
        that.source = [0];
      }
    },
  },
  methods: {
    //编辑报告
    editAjax() {
      let that = this;
      that.$api.get('report/timing-report/get-timing-report-info', { id: that.sid }, r => {
        that.$utils.returnCode(r, function () {
          that.pageType = 1;
          let data = r.data;
          let wxData = data.data.contact.wx;
          for (let key of wxData) {
            that.checkedWx.push(JSON.stringify(key))
          }
          let emailData = data.data.contact.email;
          for (let key of emailData) {
            that.checkedEmail.push(JSON.stringify(key))
          }
          let telData = data.data.contact.tel;
          for (let key of telData) {
            that.checkedTel.push(JSON.stringify(key))
          }
          that.curSendType = data.data.reportType - 1;
          that.templateId = data.data.templateId;
          that.reportTemplate.forEach((ele, index) => {
            if (ele.id == data.data.templateId) {
              that.curTpl = ele.tpl_name;
            }
          });
          that.emotion = data.data.emotion;
          that.source = data.data.isFocus;
          //去除Tv的数据
          for (let i = 0; i < that.mediaType.length; i++) {
            if (that.mediaType[i] == 'tv') {
              that.mediaType.splice(i, 1);
            }
          }
          that.searchMode = data.data.searchMode;
          that.caseIds = data.data.sids;
          that.caseNum = that.caseIds.length;
          that.includeWordList = data.data.includeWordList;
          that.includeMainWordList = data.data.includeWordList;
          let zhutiarr = [];
          let fenxiarr = [];
          for (let item of that.includeMainWordList) {
            if (item.keywordsMain && item.keywordsMain.length > 0) {
              zhutiarr = zhutiarr.concat(item.keywordsMain)
            }
          }
          for (let item of that.includeWordList) {
            if (item.keywords && item.keywords.length > 0) {
              fenxiarr = fenxiarr.concat(item.keywords)
            }
          }
          console.log(zhutiarr)
          if (zhutiarr.length > 0) {
            that.zhutiShow = true;
          }
          if (fenxiarr.length > 0) {
            that.fenxiShow = true;
          }

          //that.includeMainWordList =
          //that.currWordMainList = i.keywords_main
          that.dayData();
          //if(that.curSendType!=3){
          if (that.curSendType == 1) {
            that.weekReportTime = data.data.weekReportTime - 1;
            let wkInd = that.weeks[that.weekReportTime];
            that.curDateArr.push(wkInd);
          } else if (that.curSendType == 2) {
            let month = data.data.monthReportTime;
            that.monthReportTime = (month < 10) ? "0" + month : month;
            that.curDateArr.push(that.monthReportTime);
          }
          that.hour = data.data.dailyReportTime.split(':')[0];
          that.minute = data.data.dailyReportTime.split(':')[1];
          that.curDateArr.push(that.hour);
          that.curDateArr.push(that.minute);
          // }else{
          //     let nowTime = data.data.oneReportTime;
          //     let n = nowTime.split(' ');
          //     let n1 = n[0].split('-');
          //     let n2 = n[1].split(':');
          //     that.time = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1]-1, n2[2])
          // }
          that.$nextTick(() => {
            $(".mores .text").each(function (i) {
              $(this).text(that.curDateArr[i]);
            });
          });
          if (data.data.isWeekend == 1) {
            // that.checked = true;
            that.$set(that.reportForm, 'checked', true);
          }
        });

      });
    },
    //获取微信联系人
    getUserMethod(type) {
      let that = this;
      that.$api.get('user/contact/list', { type: type }, r => {
        that.$utils.returnCode(r, function () {
          if (type === 'wx') {
            that.wxList = r.data;
          } else if (type === 'email') {
            that.emailList = r.data;
          } else {
            that.telList = r.data;
          }
        })
      });
    },
    isHasUser(type) {
      let that = this;
      if (that.wxList == '' && type == 1) {
        that.$utils.alertText('请到“我的联系人”添加微信账号！', 300);
      } else if (that.emailList == '' && type == 2) {
        that.$utils.alertText('请到“我的联系人”添加邮箱地址！', 300);
      } else if (that.telList == '' && type == 3) {
        that.$utils.alertText('请到“我的联系人”添加手机号码！', 300);
      }
    },
    getData(allNum, name) {
      let that = this, dataObj = {}, timeArr = [];
      if (allNum == 7) {
        timeArr = that.weeks;
      } else if (allNum == 31) {
        for (let i = 1; i <= allNum; i++) {
          if (i < 10) {
            timeArr.push("0" + i);
          } else {
            timeArr.push(i);
          }
        }

      } else {
        for (let i = 0; i < allNum; i++) {
          if (i < 10) {
            timeArr.push("0" + i);
          } else {
            timeArr.push(i);
          }
        }
      }
      dataObj.time = timeArr;
      dataObj.name = name;
      dataObj.curTime = timeArr[0];
      return dataObj;
    },
    dayData() {
      let that = this, hourArr = [], minuteArr = [];
      that.dateList = [];
      switch (that.curSendType) {
        case 0:
          that.curName = '每天'
          break;
        case 1:
          that.curName = '每周';
          that.dateList.push(that.getData(7));
          break;
        case 2:
          that.curName = '每月';
          that.dateList.push(that.getData(31, '日'));
          break;
        default:
          //that.curName = '一次'
          break;
      }
      that.dateList.push(that.getData(24, '时'));
      that.dateList.push(that.getData(60, '分'));
    },
    // 选择时间
    choseTime(time, name, idx) {
      let that = this;
      switch (name) {
        case '时':
          that.hour = time;
          break;
        case '分':
          that.minute = time;
          break;
        case '日':
          that.monthReportTime = time;
          break;
        default:
          that.weekReportTime = idx;
          break;
      }

    },
    // 选择模板
    choseTemple(id, name) {
      this.templateId = id;
      this.curTpl = name;
    },
    // 报告类型
    sendType(index) {
      this.curSendType = index;
      this.dayData();
    },
    // 获取所有模板报告
    allNewReport() {
      let that = this;
      that.$api.get('report/template/get-all-template', null, r => {
        that.$utils.returnCode(r, function () {
          that.reportTemplate = r.data;
          if (that.reportTemplate.length < 10) {
            that.scrollH = 'auto';
          }
        });
      });
    },
    //时间格式
    formatDate(date) {
      //let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    // 获取平台和方案词汇
    getMediaCase() {
      let that = this;
      that.$api.get('report/timing-report/schemes-and-medias', { sid: that.caseId }, r => {
        that.$parent.loadModal(false);
        that.$utils.returnCode(r, function () {
          let data = r.data;
          //that.mediaTypeList = data.all_platforms;
          // that.caseType.push(that.caseName);
          that.caseList = data.all_schemes;
          for (let i of data.all_schemes) {//获取当前方案的关键词
            if (i.name === that.caseName) {
              that.currWordList = i.keywords_final;
              that.currWordMainList = i.keywords_main
            }
          }
          if (that.sid == undefined) {
            that.caseIds.push(that.caseId)
            that.dayData();
          } else {
            that.editAjax()
          }
        });
      })
    },

    delIncloudWord(index, id) {
      this.$delete(this.includeWordList[index].keywords, id);
    },
    delIncloudIndex(id, i) {
      let that = this;
      if (id === that.caseId) {
        // alert();
      }
      that.curIncloudWord = id;
      let len = that.caseIds.length;
      let isChose = $('.caseList .checkbox-warp').eq(i).find('.checkbox').prop('checked');
      if (len > 2 && (isChose == true)) {
        $('.caseList .checkbox-warp').eq(i).removeClass('curr');
        $('.caseList .checkbox-warp').eq(i).find('.checkbox').prop('checked', false);
        that.$utils.alertText('最多只能选择3个方案哦~', 200);
      }
    },
    delIncloudWords() {
      let that = this;
      that.includeWordList.forEach((ele, index) => {
        if (ele.id == that.curIncloudWord) {
          that.includeWordList.splice(index, 1)
        }
      });
      for (let item of that.includeWordList) {
        if (item.keywords && item.keywords.length > 0) {
          that.fenxiShow = true;
        }
      }
    },
    delIncloudMainWord(index, id) {
      this.$delete(this.includeMainWordList[index].keywordsMain, id);
      // this.includeWordList[index].splice(id,1);
    },
    delIncloudMainWords() {
      let that = this;
      that.includeMainWordList.forEach((ele, index) => {
        if (ele.id == that.curIncloudWord) {
          that.includeMainWordList.splice(index, 1)
        }
      });
      for (let item of that.includeMainWordList) {
        if (item.keywords && item.keywords.length > 0) {
          that.zhutiShow = true;
        }
      }
    },
    // 保存模板报告
    saveReport() {
      let that = this, includeWord = [], includeMainWord = [];
      // if((that.reportForm.wx == undefined ||that.reportForm.wx == '') && (that.reportForm.email == undefined || that.reportForm.email == '')&&(that.reportForm.tel == undefined ||that.reportForm.tel == '')){
      //     that.$utils.alertText('接收人的微信账号,邮箱地址,手机号码至少填写一项',350,3000);
      //     return;
      // }else
      if ((that.monthReportTime == '' || that.monthReportTime == undefined) && (this.curSendType == 2)) {
        that.$utils.alertText('请选择发送频率时间', 200);
        return;
      } else if (that.templateId == 0) {
        that.$utils.alertText('请选择模板', 200);
        return;
      }
      that.includeWordList.forEach((ele, index) => {
        if (ele.keywords) {
          ele.keywords.forEach(ele1 => {
            includeWord.push(ele1);
          });
        }
      });
      let currWordList = that.currWordList;//当前方案关键词
      includeWord = Array.from(new Set(includeWord));
      includeWord = includeWord.concat(currWordList).filter(v => includeWord.includes(v) ^ currWordList.includes(v));
      // if(includeWord.length + currWordList.length>100){
      //     that.$utils.alertText('分析词只能保留100个，请删除多余的分析词',300,2000);
      //     return;
      // }

      that.includeMainWordList.forEach((ele, index) => {
        if (ele.keywordsMain) {
          ele.keywordsMain.forEach(ele1 => {
            includeMainWord.push(ele1);
          });
        }
      });
      let currWordMainList = that.currWordMainList;//当前方案主体词
      includeMainWord = Array.from(new Set(includeMainWord));
      includeMainWord = includeMainWord.concat(currWordMainList).filter(v => includeMainWord.includes(v) ^ currWordMainList.includes(v));
      // if(includeMainWord.length + currWordMainList.length>100){
      //     that.$utils.alertText('分析词只能保留100个，请删除多余的分析词',300,2000);
      //     return;
      // }
      that.reportTime = that.hour + ':' + that.minute;
      that.isWeek = that.reportForm.checked ? 1 : 0;
      //过滤掉that.includeWordList里面的当前方案的主体词和分析词
      console.log(that.includeWordList)
      for (let item in that.includeWordList) {
        if (that.includeWordList[item].id == that.caseId) {
          that.includeWordList.splice(item, 1);
        }
      }
      //let oneReportTime = that.formatDate(that.time);
      let data = {
        'schemeId': that.caseId,
        'templateId': that.templateId,
        'wx': that.curWx,
        'email': that.curEmail,
        'tel': that.curTel,
        'reportType': that.curSendType + 1,
        'weekReportTime': that.weekReportTime + 1,
        'monthReportTime': that.monthReportTime,
        'reportTime': that.reportTime,
        'isWeekend': that.isWeek,
        "mediaType": that.mediaType,
        "emotion": that.sentiment,
        "sids": that.caseIds,
        "isFocus": that.source,
        "keyWords": includeWord,
        "includeWordList": that.includeWordList,
        'searchMode': that.searchMode,
        "keywordsMain": includeMainWord,

      };
      if (that.sid == undefined) {
        that.$api.post('report/timing-report/create', { data: data }, r => {
          that.$utils.returnCode(r, function () {
            that.$router.push({ path: '/analysis/timingTemplate' })
            that.$utils.alertText('报告添加成功！', 200);
            that.$store.dispatch('show/changeToast', { text: '报告添加成功！' })
          });
        });
      } else {
        let data1 = data;
        data1.id = that.sid;
        that.$api.post('report/timing-report/edit', { data: data1 }, r => {
          that.$utils.returnCode(r, function () {
            that.$utils.alertText('报告修改成功！', 200);
            that.$store.dispatch('show/changeToast', { text: '报告修改成功！' })
            that.$router.push({ path: '/analysis/timingTemplate' })
          });
        })
      }
    },
    cancelReport() {
      this.$router.push({ path: '/analysis/timingTemplate' })
    },
    addTemple() {
      this.$router.push({ path: '/analysis/addNewOrdinaryTemplate', query: { fromTiming: 'newtemp', timeId: this.sid } })
      // let routeData = this.$router.resolve({ path: '/addOrdinaryTemplate'});
      // window.open(routeData.href, '_blank');
    }
  }
}
</script>
<style scoped>/* .checkbox-group .checkbox-box{width:auto} */</style>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/presentation/addTimingTemplate.vue